import React, { useEffect, useMemo, useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import rehypeHighlight from "rehype-highlight";
import styles from "./Book.module.css";


function joinUrl(...parts) {
  return parts
    .filter(Boolean)
    .map((p, i) => {
      let s = String(p);
      if (i === 0) return s.replace(/\/+$/, "");
      return s.replace(/^\/+/, "").replace(/\/+$/, "");
    })
    .join("/");
}

export default function MarkdownRenderer({ basePath, file }) {
  const [md, setMd] = useState("");
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  const url = useMemo(() => {
    const publicUrl = process.env.PUBLIC_URL || "";
    return joinUrl(publicUrl, basePath, file);
  }, [basePath, file]);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    setErr("");
    setMd("");

    fetch(url)
      .then(async (r) => {
        const text = await r.text();
        const looksLikeHtml =
          text.trim().startsWith("<!DOCTYPE html>") ||
          text.includes('<div id="root">') ||
          text.includes("<html");
        if (!r.ok || looksLikeHtml) {
          throw new Error(`No se encontró el markdown: ${url}`);
        }
        return text;
      })
      .then((txt) => {
        if (!alive) return;
        setMd(txt);
        setLoading(false);
      })
      .catch((e) => {
        if (!alive) return;
        setErr(String(e?.message || e));
        setLoading(false);
      });

    return () => {
      alive = false;
    };
  }, [url]);

  if (loading) return <div className={styles.loading}>Cargando…</div>;
  if (err) return <div className={styles.error}>{err}</div>;

  return (
    <div className={styles.md}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeRaw, rehypeHighlight]}
        components={{
          a: (props) => <a {...props} target="_blank" rel="noreferrer" />,
          img: (props) => (
            <img {...props} alt={props.alt || ""} className={styles.mdImg} />
          ),
          table: (props) => <table className={styles.mdTable} {...props} />,
        }}
      >
        {md}
      </ReactMarkdown>
    </div>
  );
}
